import { useAtom } from "jotai";
import Link from "next/link";
import { useRouter } from "next/router";
import { Dispatch, SetStateAction } from "react";

import { startAlimProcess } from "@/businessLogics/alimLogic";
import {
  alimModalCourseAtom,
  alimModalStepAtom,
  showAlimModalAtom,
} from "@/states/notification";

import * as S from "./style";

export function CustomLink({
  url,
  children,
  userInfo,
  isOutsideLink,
  course,
  isMobile,
  setIsSideMenuOpen,
}: {
  url: string;
  children: React.ReactNode;
  userInfo: UserInfo;
  isOutsideLink?: boolean;
  course?: string;
  isMobile?: boolean;
  setIsSideMenuOpen?: Dispatch<SetStateAction<boolean>>;
}) {
  const router = useRouter();
  const noLandingAlertMessage = userInfo
    ? "선택하신 코스는 알림 신청을 진행 중입니다."
    : "선택하신 코스는 알림 신청을 진행 중입니다.\n" +
      "로그인 후 알림 신청이 가능합니다.";
  const [, setShowModal] = useAtom(showAlimModalAtom);
  const [, setStep] = useAtom(alimModalStepAtom);
  const [, setAlimModalCourse] = useAtom(alimModalCourseAtom);

  function handleClickNoLandingPage(e) {
    e.preventDefault();
    alert(noLandingAlertMessage);
    if (isMobile)
      return router.pathname === "/"
        ? setIsSideMenuOpen(false)
        : (window.location.href = "/");
    window.location.href = "/#course-div";
    router.push("/", undefined, { scroll: false });
  }

  async function courseRedirectHandeler(e) {
    e.preventDefault();
    if (course === "pm") {
      window.open("https://bit.ly/3Z7q2Ey", "_blank");
      return;
    }
    await setAlimModalCourse(course);
    await startAlimProcess(userInfo, course, setShowModal, setStep);
  }

  //랜딩 없는 UIUX 디자이너 코스 용
  if (url === "alert") {
    return (
      <S.ALink href="#" onClick={handleClickNoLandingPage}>
        {children}
      </S.ALink>
    );
  }

  if (url === "alim") {
    return (
      <S.ALink href="" onClick={courseRedirectHandeler}>
        {children}
      </S.ALink>
    );
  }

  if (isOutsideLink) {
    return (
      <Link
        href={url}
        target={isOutsideLink ? "_blank" : "_self"}
        rel="noreferrer"
      >
        {children}
      </Link>
    );
  }
  return <S.ALink href={url}>{children}</S.ALink>;
}
